import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { List } from "immutable";

const Option = Select.Option;

const yearWiseSorter = (a, b) => {
    const firstYear = a.start_date,
        secondYear = b.start_date;
    if (firstYear.isAfter(secondYear)) {
        return 1;
    }
    return -1;
};

class FinancialYearSelector extends React.Component {
    onSelect = value => {
        if (value === "disable") {
            this.props.onFinancialYearSelect("disable");
            return;
        }
        const year = this.props.financialYears.find(
            _ => _.id === Number(value)
        );
        const oneYearBefore = this.props.financialYears.find(
            _ => _.start_date.diff(year.start_date, "years") === -1
        );
        this.props.onFinancialYearSelect(year, oneYearBefore);
    };

    render() {
        return (
            <Select
                style={{
                    width: "200px"
                }}
                disabled={this.props.isRiskApprover}
                onSelect={this.onSelect}
                value={
                    this.props.disabled
                        ? "disable"
                        : this.props.year && String(this.props.year.id)
                }
            >
                <Option key={"disabled"} value={"disable"}>
                    Disabled
                </Option>
                {this.props.financialYears.sort(yearWiseSorter).map(_ => (
                    <Option key={_.id} value={String(_.id)}>
                        {_.name}
                    </Option>
                ))}
            </Select>
        );
    }
}

FinancialYearSelector.propTypes = {
    financialYears: PropTypes.object,
    onFinancialYearSelect: PropTypes.func,
    year: PropTypes.object,
    disabled: PropTypes.bool,
    isRiskApprover: PropTypes.bool
};

FinancialYearSelector.defaultProps = {
    financialYears: new List([])
};

export default FinancialYearSelector;
